import { useState, useCallback } from 'react';
import { chatService, type SessionSummary } from '../../../services/chat.service';
import { toast } from 'sonner';

export function useSessions() {
  const [sessions, setSessions] = useState<SessionSummary[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchSessions = useCallback(async () => {
    setLoading(true);
    try {
      const data = await chatService.listSessions();
      setSessions(data);
    } catch {
      toast.error('Could not load chat history');
    } finally {
      setLoading(false);
    }
  }, []);

  const createSession = useCallback(async (): Promise<SessionSummary> => {
    const session = await chatService.createSession();
    setSessions((prev) => [session, ...prev]);
    return session;
  }, []);

  const deleteSession = useCallback(async (sessionId: string) => {
    try {
      await chatService.deleteSession(sessionId);
      setSessions((prev) => prev.filter((s) => s.session_id !== sessionId));
      toast.success('Chat deleted');
    } catch {
      toast.error('Could not delete chat');
    }
  }, []);

  const updateTitle = useCallback((sessionId: string, title: string) => {
    setSessions((prev) =>
      prev.map((s) => (s.session_id === sessionId ? { ...s, title } : s))
    );
  }, []);

  return { sessions, loading, fetchSessions, createSession, deleteSession, updateTitle };
}
